const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading="lazy"
  return newImage;
}

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      input.addEventListener('change', (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const handleProduct = wrapper.dataset.product;

        if (!event.currentTarget.checked || !primaryImage || !handleProduct) return;

        // Update link & cart
        const swatchLink = wrapper.querySelector('.js-color-swatches-link');
        if (swatchLink) swatchLink.setAttribute('href', event.currentTarget.dataset.variantLink);

        const addBtn = wrapper.querySelector('.card__add-to-cart button[name="add"]');
        if (addBtn) {
          addBtn.setAttribute('aria-disabled', false);
          addBtn.querySelector('> span')?.classList.remove('hidden');
          addBtn.querySelector('.sold-out-message')?.classList.add('hidden');
          wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
        }

        const currentColor = event.currentTarget.value.toLowerCase().trim();

        jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
          
          // ✅ Find variant whose options include this color
          const variant = product.variants.find(v =>
            v.featured_image &&
            v.options.some(opt => opt.toLowerCase().trim() === currentColor)
          );

          // ✅ Fallback: find any variant with this color even without featured_image
          const fallbackVariant = !variant && product.variants.find(v =>
            v.options.some(opt => opt.toLowerCase().trim() === currentColor)
          );

          const targetVariant = variant || fallbackVariant;

          if (!targetVariant) {
            console.warn('No variant found for color:', currentColor);
            return;
          }

          const featuredImage = targetVariant.featured_image;
          if (!featuredImage) {
            console.warn('Variant has no featured_image:', targetVariant);
            return;
          }

          // ✅ Get the actual <img> inside the .media--first div
          const imgEl = primaryImage.querySelector('img');
          if (!imgEl) {
            console.warn('No <img> found inside .media--first');
            return;
          }

          const newSrc = featuredImage.src;
          const newSrcset = generateSrcset(featuredImage, [165, 360, 533, 720, 940, 1066]);

          // ✅ Swap with fade
          imgEl.style.transition = 'opacity 0.2s ease';
          imgEl.style.opacity = '0';

          setTimeout(() => {
            imgEl.src = newSrc;
            imgEl.srcset = newSrcset;
            imgEl.alt = featuredImage.alt || product.title;
            imgEl.style.opacity = '1';
          }, 200);

        }).fail(function() {
          console.error('Failed to fetch product JSON for:', handleProduct);
        });
      });
    });
  });
}

function colorSwatches() {
  checkSwatches();

  document.addEventListener('shopify:section:load', function () {
    checkSwatches();
  });
}

(function () {
colorSwatches();
})()

